<template src='./form-validation.html'></template>

<script>

export default {
  props: ['revisionErrors', 'revisionWarnings'],
  data () {
    return {
      validationDialog: false,
      validationData: {},
      validationTitle: '',
      validationTitleColor: ''
    }
  },
  methods: {
    showErrors () {
      this.validationTitle = this.$t('validation.error')
      this.validationTitleColor = 'red'
      this.validationDialog = true
      this.validationData = this.revisionErrors
    },
    showWarnings () {
      this.validationTitle = this.$t('validation.warning')
      this.validationTitleColor = 'goldenrod'
      this.validationDialog = true
      this.validationData = this.revisionWarnings
    }
  }
}
</script>
